import SummaryDueAtSigningLabelAndNumber from './SummaryDueAtSigningLabelAndNumber.interstate';
import SummaryDueAtSigningSlideOut from './SummaryDueAtSigningSlideOut.interstate';
import { useSummaryDueAtSigning } from './hooks/useSummaryDueAtSigning';

interface SummaryDueAtSigningProps {
    inputValue?: string;
}

const SummaryDueAtSigning = (props: SummaryDueAtSigningProps) => {
    const { inputValue } = props;
    const { showSlideOut, toggleSlideOut, overrides } = useSummaryDueAtSigning();

    return (
        <>
            <SummaryDueAtSigningLabelAndNumber toggleSlideOut={toggleSlideOut} inputValue={inputValue} />
            {showSlideOut && <SummaryDueAtSigningSlideOut show={showSlideOut} onHide={toggleSlideOut} overrides={overrides} />}
        </>
    );
};

export default SummaryDueAtSigning;
